import { isV2Application } from "src/pages/BackgroundSurveyScreen/types/ApplicationWizardTypes";
import { UserAccount } from "src/types/User";

const LEGACY_NON_CDL_REJECTION_FEEDBACK =
  "Thanks for applying. Based on the information you shared, we're not able to move you forward in the program right now.";
const AUTO_REJECTION_INTERNAL_PREFIX = "Auto-rejected: ";

/**
 * Non-CDL decisions written before public rejection reasons were persisted put
 * the concrete reasons in internalFeedback and saved generic status details.
 * Unwrap only that exact legacy shape so custom/manual rejection copy is never
 * replaced by an internal note.
 */
export default function resolveRejectedApplicationDetails(
  user: UserAccount
): string | undefined {
  const persistedDetails = user.applicationStatusDetails;
  if (
    persistedDetails !== LEGACY_NON_CDL_REJECTION_FEEDBACK ||
    !user.application ||
    !isV2Application(user.application)
  ) {
    return persistedDetails;
  }

  const decision = user.application.publicEligibilityDecision;
  const internalFeedback = decision?.internalFeedback;
  if (
    decision?.publicFeedback !== LEGACY_NON_CDL_REJECTION_FEEDBACK ||
    !internalFeedback?.startsWith(AUTO_REJECTION_INTERNAL_PREFIX)
  ) {
    return persistedDetails;
  }

  const reasons = internalFeedback
    .slice(AUTO_REJECTION_INTERNAL_PREFIX.length)
    .split("; ")
    .filter(Boolean);
  if (reasons.length === 0) return persistedDetails;
  if (reasons.length === 1) return reasons[0];
  return reasons.map((reason) => `• ${reason}`).join("\n");
}
